import request from 'local_modules/request'
import { reducers, getState } from 'redux/core'
import { constants } from 'helpers'


const setFetching = (isFetching) => reducers.marketplace.adminCancelFoodPage.setFetching(isFetching)

const fetchSchools = () => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  return request.get(prefix.schools + `?all=false`)
    .then(({ data }) => data)
    .then((schools) => {
      reducers.marketplace.adminCancelFoodPage.setSchools(schools.map(({ id, title }) => ({
        title,
        value: id,
      })))
    })
    .catch((error) => {
      console.log(error)
    })
}

const setSchool = (value) => {
  reducers.marketplace.adminCancelFoodPage.setSchool(value)
}

const fetchClasses = () => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory,
      },
      adminCancelFoodPage: {
        school: schoolId,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu

  return request.get(prefix.schools + `/${schoolId}?all=false`)
    .then(({ data }) => data)
    .then((classes) => {
      reducers.marketplace.adminCancelFoodPage.setClasses(classes.map(({ id, grade, letter }, index) => ({
        title: grade + letter,
        value: index + 1,
        classId: id,
      })))
    })
    .catch((error) => {
      console.log(error)
    })
}

// const fetch = ({ fromInt, toInt }) => {
//   const {
//     marketplace: {
//       layersNavigation: {
//         category: selectedCategory,
//       },
//     },
//   } = getState()
  
//   const isRpc = selectedCategory === 'rpc'
//   const prefix = isRpc ? constants.rpc : constants.edu
//   const {
//     me: { id },
//     marketplace: { accessLevel: { edu, rpc } },
//   } = getState()
//   const { cashierAccessLevel } = !isRpc ? edu : rpc 

//   const schoolId = cashierAccessLevel.find(({ cashier }) => id === cashier.id).school.id

//   return (
//     fetchClasses()
//     .then(() => fetchOptions())
//     .then(() => {
//       request.post(prefix.cashierRefund + `/${schoolId}`, {
//         fromInt,
//         toInt,
//       })
//         .then(({ data }) => data)
//         .then((order) => {
//           reducers.marketplace.cashierCancelFoodPage.setOrders(order)
  
//           return order
//         })
//     })
//   )
// }

const cancelBulkSchool = (schoolId, from, to) => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  console.log('bulk cancel school', { schoolId, isRpc, prefix })
  // console.log(`request.post(prefix.cashierCancelBulkSchool + ${`/${schoolId}/withoutCheck?from=${from}&to=${to}`}, {})`)
  return request.post(prefix.adminCancelBulkSchool + `/${schoolId}/withoutCheck?from=${from}&to=${to}`, {})
    .then(({ data }) => data)
    .catch((error) => {
      console.log(error)

      return {}
    })
}

const cancelBulkClass = (classId, from, to) => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  console.log('bulk cancel class', { classId })
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  // console.log(`request.post(prefix.cashierCancelBulkClass + ${`/${classId}/withoutCheck?from=${from}&to=${to}, {})`}`)
  return request.post(prefix.adminCancelBulkClass + `/${classId}/withoutCheck?from=${from}&to=${to}`, {})
    .then(({ data }) => data)
    .catch((error) => {
      console.log(error)

      return {}
    })
}


export default {
  setFetching,
  cancelBulkSchool,
  cancelBulkClass,
  // fetch,
  setSchool,
  fetchClasses,
  fetchSchools,
}
